// extracted by mini-css-extract-plugin
export default {"container":"CitySelector_container__hBfaG","label":"CitySelector_label__1zRAz","select":"CitySelector_select__OAIKY"};